import { useState, useEffect, useCallback, useRef } from "react";
import CheckIcon from "@mui/icons-material/Check";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import StarIcon from "@mui/icons-material/Star";
import Header from "components/Header";
import Footer from "components/Footer";
import { Img } from "components";
import * as CUSTOM from "../../utils/helper/custom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { updateOrderData } from "redux/reducers/orderData";
import { t } from "i18next";
import { getAuth } from "redux/reducers/loginData";
import globalRequest from "../../utils/global/globalRequest";
import * as APIS from "../../utils/helper/Enum";

export const PENDING_RESERVATION_KEY = "pending_reservation_data";

const PRIMARY = "#7C1D46";
const PRIMARY_LIGHT = "#FDF2F8";

const PACKAGES = [
    { id: "celebration_pkg", nameKey: "pkg_celebration_name", durationKey: "pkg_duration_standard", price: 142, cakeKey: "pkg_celebration_cake", pizza: "-", balloons: "-", featuresKey: "pkg_celebration_features", hours: 1, },
    {
        id: "stage_1",
        nameKey: "pkg_stage1_name",
        durationKey: "pkg_duration_1hr",
        price: 299,
        cakeKey: "pkg_stage1_cake",
        pizza: "1",
        balloons: "3",
        featuresKey: "pkg_stage_features",
        hours: 1,
    },
    {
        id: "stage_2",
        nameKey: "pkg_stage2_name",
        durationKey: "pkg_duration_2hr",
        price: 499,
        cakeKey: "pkg_stage2_cake",
        pizza: "2",
        balloons: "6",
        featuresKey: "pkg_stage_features",
        hours: 2,
    },
    {
        id: "stage_3",
        nameKey: "pkg_stage3_name",
        durationKey: "pkg_duration_3hr",
        price: 749,
        cakeKey: "pkg_stage3_cake",
        pizza: "3",
        balloons: "9",
        featuresKey: "pkg_stage_features",
        hours: 3,
    },
    {
        id: "stage_4",
        nameKey: "pkg_stage4_name",
        durationKey: "pkg_duration_4hr",
        price: 998,
        cakeKey: "pkg_stage4_cake",
        pizza: "4",
        balloons: "12",
        featuresKey: "pkg_stage_features",
        hours: 4,
    },
];

const ICONS = {
    hours: "/images/clock.png",
    people: "/images/person.png",
    chairs: "/images/chair.png",
    cakes: "/images/cake.png",
};
const CHECK_ICON = "/images/checkDone.svg";


function ConflictToast({ message, visible }) {
    return (
        <div style={{
            position: "fixed",
            top: 28,
            left: "50%",
            transform: `translateX(-50%) translateY(${visible ? "0" : "-20px"})`,
            opacity: visible ? 1 : 0,
            transition: "opacity 0.35s ease, transform 0.35s ease",
            pointerEvents: "none",
            zIndex: 9999,
            background: "#7C1D46",
            color: "white",
            borderRadius: 12,
            padding: "14px 24px",
            boxShadow: "0 8px 32px rgba(124,29,70,0.28)",
            fontSize: 14,
            fontFamily: "Inter",
            fontWeight: 500,
            maxWidth: 380,
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            gap: 10,
            whiteSpace: "pre-wrap",
        }}>
            {/* Warning icon inline SVG */}
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0 }}>
                <circle cx="10" cy="10" r="9" stroke="white" strokeWidth="1.6" />
                <rect x="9.1" y="5.5" width="1.8" height="6" rx="0.9" fill="white" />
                <rect x="9.1" y="13" width="1.8" height="1.8" rx="0.9" fill="white" />
            </svg>
            {message}
        </div>
    );
}

// TIME_SLOTS is kept for reference but slots now come from API (1-hour each)
// const TIME_SLOTS = [
//     { id: "09", label: "09:00AM - 12:00PM" },
//     { id: "12", label: "12:00PM - 03:00PM" },
//     { id: "03", label: "03:00PM - 06:00PM" },
//     { id: "06", label: "06:00PM - 09:00PM", reserved: true },
//     { id: "009", label: "09:00PM - 12:00AM" },
// ];

const CAFE_IMAGES = [
    "images/reserve1.jpg",
    "images/reserve2.jpg",
    "images/reserve3.jpg",
    "images/reserve4.jpg"
];

const PARTY_IMAGES = [
    "images/reserve1.jpg",
    "images/reserve2.jpg",
    "images/reserve3.jpg",
    "images/reserve4.jpg"
];

const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

function getNext7Days() {
    const today = new Date();
    return Array.from({ length: 7 }, (_, i) => {
        const d = new Date(today);
        d.setDate(today.getDate() + i);
        return d;
    });
}

/* Accordion */
function Accordion({ number, title, isOpen, isCompleted, onToggle, children }) {
    return (
        <div style={{
            background: "white", borderRadius: 16, marginBottom: 14,
            boxShadow: "0 2px 10px rgba(0,0,0,.07)", overflow: "hidden",
        }}>
            <div onClick={onToggle} style={{
                display: "flex", alignItems: "center", gap: 16,
                padding: "20px 28px", cursor: "pointer", userSelect: "none",
            }}>
                <div style={{
                    width: 36, height: 36, borderRadius: "50%",
                    background: isCompleted ? PRIMARY : isOpen ? PRIMARY : "#F3F4F6",
                    color: isCompleted || isOpen ? "white" : "#777",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 15, fontWeight: 700, flexShrink: 0, transition: "all .3s",
                }}>
                    {isCompleted ? <img
                        src={CHECK_ICON}
                        alt="done"
                        style={{
                            width: 28,
                            height: 28,
                            padding: "2%",
                            objectFit: "contain"
                        }}
                    /> : number}
                </div>
                <span style={{ fontWeight: 700, fontSize: 18, flex: 1, color: "#1a1a1a" }}>{title}</span>
                {isOpen
                    ? <KeyboardArrowUpIcon sx={{ color: "#aaa", fontSize: 26 }} />
                    : <KeyboardArrowDownIcon sx={{ color: "#aaa", fontSize: 26 }} />}
            </div>
            <div style={{ maxHeight: isOpen ? "1100px" : "0", overflow: "hidden", transition: "max-height .45s ease" }}>
                <div style={{ padding: "0 28px 28px" }}>{children}</div>
            </div>
        </div>
    );
}

/* Package Card */
function PackageCard({ pkg, selected, onSelect }) {
    const details = [
        { key: "duration", icon: ICONS.hours, text: t(pkg.durationKey) },
        { key: "cake",     icon: ICONS.cakes,  text: t(pkg.cakeKey) },
    ];
    if (pkg.pizza && pkg.pizza !== "-") {
        details.push({ key: "pizza",    icon: "pizza",    text: `${pkg.pizza} ${t("pkg_pizza_qty")}` });
    }
    if (pkg.balloons && pkg.balloons !== "-") {
        details.push({ key: "balloons", icon: "balloons", text: `${pkg.balloons} ${t("pkg_helium_balloons")}` });
    }
    if (pkg.featuresKey) {
        details.push({ key: "features", icon: "check",    text: t(pkg.featuresKey) });
    }

    return (
        <div onClick={onSelect} style={{
            border: `2px solid ${selected ? PRIMARY : "#E5E7EB"}`,
            borderRadius: 14, padding: "20px 22px", cursor: "pointer",
            background: selected ? PRIMARY_LIGHT : "white", transition: "all .2s",
            height: "100%", display: "flex", flexDirection: "column"
        }}>
            <div
                style={{
                    color: "var(--Blacks-700, #3E4147)",
                    textAlign: "center",
                    fontFamily: "Unbounded",
                    fontSize: 20,
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "28px",
                    marginBottom: 14,
                    display: "flex",
                    justifyContent: "start"
                }}
            >
                {t(pkg.nameKey)}
            </div>
            <div style={{ flex: 1 }}>
                {details.map(({ key, icon, text }) => (
                    <div
                        key={key}
                        style={{
                            color: "var(--Blacks-400, #727783)",
                            fontFamily: "Inter",
                            fontSize: 16,
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "24px",
                            marginBottom: 10,
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 8
                        }}
                    >
                        {icon === "check" || icon === "pizza" || icon === "balloons" ? (
                            <CheckIcon sx={{ color: PRIMARY, fontSize: 24, flexShrink: 0 }} />
                        ) : (
                            <img
                                src={icon}
                                alt={key}
                                style={{
                                    width: 24,
                                    height: 24,
                                    aspectRatio: "1/1",
                                    flexShrink: 0
                                }}
                            />
                        )}
                        <span style={{ wordBreak: "break-word" }}>{text}</span>
                    </div>
                ))}
            </div>
            <div
                style={{
                    color: "var(--Blacks-900, #1A1A1A)",
                    textAlign: "start",
                    fontFamily: "Unbounded",
                    fontSize: 22,
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "28px",
                    marginTop: 16,
                    display: "flex"
                }}
            >
                <Img src="images/Groupsar2.svg" alt="sar" className="w-5 h-5 mt-1" /> &nbsp; {pkg.price}
            </div>
        </div>
    );
}

/* Continue Btn */
function ContinueBtn({ disabled, onClick }) {
    return (
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 22 }}>
            <button onClick={onClick} disabled={disabled} style={{
                background: disabled ? "#D1D5DB" : PRIMARY, color: "white",
                border: "none", borderRadius: 10, padding: "13px 32px",
                cursor: disabled ? "not-allowed" : "pointer",
                fontWeight: 700, fontSize: 14, fontFamily: "Unbounded", transition: "background .2s",
            }}>
                {t("continue")}
            </button>
        </div>
    );
}

/* Main */
export default function ReservationPage() {
    const [openStep, setOpenStep] = useState(1);
    const [completed, setCompleted] = useState(new Set());
    const [selectedPkg, setSelectedPkg] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState(null);

    const [slotConflictMsg, setSlotConflictMsg] = useState("");
    const [toastVisible, setToastVisible] = useState(false);
    const toastTimerRef = useRef(null);
    const selectedSlotRef = useRef(null);

    // Mouse drag-to-scroll refs
    const sliderRef = useRef(null);
    const isDown = useRef(false);
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);

    const onMouseDown = (e) => {
        isDown.current = true;
        isDragging.current = false;
        startX.current = e.pageX - sliderRef.current.offsetLeft;
        scrollLeft.current = sliderRef.current.scrollLeft;
    };
    const onMouseLeave = () => { isDown.current = false; };
    const onMouseUp = () => { isDown.current = false; };
    const onMouseMove = (e) => {
        if (!isDown.current) return;
        e.preventDefault();
        const x = e.pageX - sliderRef.current.offsetLeft;
        const walk = (x - startX.current) * 2;
        if (Math.abs(walk) > 5) {
            isDragging.current = true;
        }
        sliderRef.current.scrollLeft = scrollLeft.current - walk;
    };

    const handleSelectPkg = (pkgId) => {
        if (isDragging.current) return;
        setSelectedPkg(pkgId);
    };
    const [form, setForm] = useState({ firstName: "", lastName: "", phone: "", guests: "", special: "" });
    const [imgIdx, setImgIdx] = useState(0);
    const [confirmed, setConfirmed] = useState(false);

    const [pendingLoginRedirect, setPendingLoginRedirect] = useState(false);

    const [loginMsg, setLoginMsg] = useState(false);

    const [fetchedSlots, setSetchedSlots] = useState([]);
    const [slotsLoading, setSlotsLoading] = useState(false);
    const [slotsError, setSlotsError] = useState("");
    const [isReservationDraftHydrated, setIsReservationDraftHydrated] = useState(false);

    const isMobile = window.innerWidth <= 600;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const auth = useSelector(getAuth);

    const days = getNext7Days();
    const images = completed.has(1) && completed.has(2) ? PARTY_IMAGES : CAFE_IMAGES;

    const selectedPkgData = PACKAGES.find(p => p.id === selectedPkg);
    const pkgHours = selectedPkgData?.hours || 1;

    const isSlotInRange = (slot) => {
        if (!selectedSlot || fetchedSlots.length === 0) return false;
        const startIndex = fetchedSlots.findIndex(s => s.openTime === selectedSlot);
        if (startIndex === -1) return false;
        const slotIndex = fetchedSlots.findIndex(s => s.openTime === slot.openTime);
        return slotIndex >= startIndex && slotIndex < startIndex + pkgHours;
    };

    const isSlotRangeStart = (slot) => {
        return selectedSlot === slot.openTime;
    };

    const isSlotRangeEnd = (slot) => {
        if (!selectedSlot || fetchedSlots.length === 0) return false;
        const startIndex = fetchedSlots.findIndex(s => s.openTime === selectedSlot);
        if (startIndex === -1) return false;
        const endIndex = startIndex + pkgHours - 1;
        const slotIndex = fetchedSlots.findIndex(s => s.openTime === slot.openTime);
        return slotIndex === endIndex;
    };

    const showConflictToast = (msg) => {
        if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
        setSlotConflictMsg(msg);
        setToastVisible(true);
        toastTimerRef.current = setTimeout(() => {
            setToastVisible(false);
            setTimeout(() => setSlotConflictMsg(""), 350); 
        }, 1800);
    };

    useEffect(() => {
        selectedSlotRef.current = selectedSlot;
    }, [selectedSlot]);

    const handleSlotClick = (slot) => {
        if (slot.reserved) return;

        const slotIndex = fetchedSlots.findIndex(s => s.openTime === slot.openTime);

        if (slotIndex + pkgHours > fetchedSlots.length) {
            showConflictToast(
                t("notEnoughSlotsForPackage") ||
                "Not enough time slots available from here for the selected package duration."
            );
            return;
        }

        const rangeSlots = fetchedSlots.slice(slotIndex, slotIndex + pkgHours);
        const hasConflict = rangeSlots.some(s => s.reserved);

        if (hasConflict) {
            showConflictToast(
                t("slotRangeConflict") ||
                "Aap ye slot select nahi kar sakte. Reserved time ke baad ka slot select karein."
            );
            return;
        }

        setSlotConflictMsg("");
        setToastVisible(false);
        setSelectedSlot(slot.openTime);
    };

    useEffect(() => {
        const interval = setInterval(() => setImgIdx(i => (i + 1) % images.length), 3500);
        return () => clearInterval(interval);
    }, [images.length]);

    useEffect(() => {
        const raw = localStorage.getItem(PENDING_RESERVATION_KEY);
        if (!raw) {
            setIsReservationDraftHydrated(true);
            return;
        }

        try {
            const saved = JSON.parse(raw);

            if (saved.selectedPkg) {
                setSelectedPkg(saved.selectedPkg);
                setCompleted(prev => new Set([...prev, 1]));
            }

            if (saved.selectedDate) {
                setSelectedDate(new Date(saved.selectedDate));
            }

            if (saved.selectedSlot) {
                setSelectedSlot(saved.selectedSlot);
            }

            if (saved.selectedDate && saved.selectedSlot) {
                setCompleted(prev => new Set([...prev, 1, 2]));
            }

            if (saved.form) {
                setForm(saved.form);
            }

            if (saved.selectedPkg && saved.selectedDate && saved.selectedSlot) {
                setOpenStep(3);
            }

            if (auth?.id) {
                localStorage.removeItem(PENDING_RESERVATION_KEY);
            }
        } catch (e) {
            localStorage.removeItem(PENDING_RESERVATION_KEY);
        }
        setIsReservationDraftHydrated(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (auth?.id && pendingLoginRedirect) {
            setPendingLoginRedirect(false);
            localStorage.removeItem(PENDING_RESERVATION_KEY);
        }
    }, [auth?.id, pendingLoginRedirect]);

    // const fetchSlots = useCallback(async (pkgId, date) => {
    //     if (!pkgId || !date) return;

    //     const pkg = PACKAGES.find(p => p.id === pkgId);
    //     if (!pkg) return;

    //     setSlotsLoading(true);
    //     setSlotsError("");
    //     setSetchedSlots([]);
    //     if (isReservationDraftHydrated) {
    //         setSelectedSlot(null);
    //     }
    //     setSlotConflictMsg("");

    //     try {
    //         const dateStr = date.toLocaleDateString("en-CA");
    //         const dayName = DAY_NAMES[date.getDay()];

    //         let response = await globalRequest(
    //             APIS.ORDER.RESERVATION_SLOTS_API,
    //             "get",
    //             {},
    //             {
    //                 params: {
    //                     date: dateStr,
    //                     day: dayName,
    //                     package_hours: pkg.hours,
    //                 },
    //             },
    //             true
    //         );
    //         response = response?.data;

    //         if (response?.status === "SUCCESS" && response?.data?.slots?.length > 0) {
    //             const incomingSlots = response.data.slots;
    //             setSetchedSlots(incomingSlots);

    //             // Keep restored slot when returning from login, but only if still valid.
    //             if (!isReservationDraftHydrated && selectedSlotRef.current) {
    //                 const restoredSlotIndex = incomingSlots.findIndex((s) => s.openTime === selectedSlotRef.current);
    //                 if (restoredSlotIndex === -1 || restoredSlotIndex + pkg.hours > incomingSlots.length) {
    //                     setSelectedSlot(null);
    //                 } else {
    //                     const selectedRange = incomingSlots.slice(restoredSlotIndex, restoredSlotIndex + pkg.hours);
    //                     if (selectedRange.some((s) => s.reserved)) {
    //                         setSelectedSlot(null);
    //                     }
    //                 }
    //             }
    //         } else {
    //             setSlotsError(t("timeslot_unavailable"));
    //         }
    //     } catch (err) {
    //         console.error("Slot fetch error:", err?.message);
    //         setSlotsError(t("timeslot_error"));
    //     } finally {
    //         setSlotsLoading(false);
    //     }
    // }, [isReservationDraftHydrated]);

    // Trigger fetch whenever package OR date changes
    
    // ─── fetchSlots function ke andar — sirf ye 2 jagah change karni hain ───

const fetchSlots = useCallback(async (pkgId, date) => {
    if (!pkgId || !date) return;

    const pkg = PACKAGES.find(p => p.id === pkgId);
    if (!pkg) return;

    setSlotsLoading(true);
    setSlotsError("");
    setSetchedSlots([]);

    if (!isReservationDraftHydrated) {
        setSelectedSlot(null);
    }
    // ── FIX 1 END ──

    setSlotConflictMsg("");

    try {
        const dateStr = date.toLocaleDateString("en-CA");
        const dayName = DAY_NAMES[date.getDay()];

        let response = await globalRequest(
            APIS.ORDER.RESERVATION_SLOTS_API,
            "get",
            {},
            {
                params: {
                    date: dateStr,
                    day: dayName,
                    package_hours: pkg.hours,
                },
            },
            true
        );
        response = response?.data;

        if (response?.status === "SUCCESS" && response?.data?.slots?.length > 0) {
            const incomingSlots = response.data.slots;
            setSetchedSlots(incomingSlots);

            // ── FIX 2: Restored slot ko tab validate karo jab hydration complete HO CHUKI HO ──
            // Pehle tha: if (!isReservationDraftHydrated && selectedSlotRef.current)
            // Problem: login ke baad isReservationDraftHydrated=true tha toh ye block skip hota tha
            // aur slot validate/restore nahi hota tha. Ab isReservationDraftHydrated=true par bhi
            // selectedSlotRef.current ka valid slot check karo.
            if (selectedSlotRef.current) {
                const restoredSlotIndex = incomingSlots.findIndex(
                    (s) => s.openTime === selectedSlotRef.current
                );
                if (
                    restoredSlotIndex === -1 ||
                    restoredSlotIndex + pkg.hours > incomingSlots.length
                ) {
                    setSelectedSlot(null);
                } else {
                    const selectedRange = incomingSlots.slice(
                        restoredSlotIndex,
                        restoredSlotIndex + pkg.hours
                    );
                    if (selectedRange.some((s) => s.reserved)) {
                        setSelectedSlot(null);
                    }
                    // ── Slot valid hai, setSelectedSlot ki zaroorat nahi — ref already set hai ──
                }
            }
            // ── FIX 2 END ──

        } else {
            setSlotsError(t("timeslot_unavailable"));
        }
    } catch (err) {
        console.error("Slot fetch error:", err?.message);
        setSlotsError(t("timeslot_error"));
    } finally {
        setSlotsLoading(false);
    }
}, [isReservationDraftHydrated]);
    useEffect(() => {
        if (selectedPkg && selectedDate) {
            fetchSlots(selectedPkg, selectedDate);
        }
    }, [selectedPkg, selectedDate, fetchSlots]);
    // ─────────────────────────────────────────────────────────────────────────

    const toggle = n => setOpenStep(p => (p === n ? null : n));
    const finishStep = (n, next) => {
        setCompleted(p => new Set([...p, n]));
        setOpenStep(next ?? null);
    };

    const monthLabel = t(MONTH_NAMES[days[0].getMonth()].toLowerCase()) + " " + days[0].getFullYear();
    const allReady = selectedPkg && selectedDate && selectedSlot && form.firstName && form.lastName && form.phone && form.guests;

    const handleConfirmReservation = () => {
        if (!allReady) return;

        const pkgData = PACKAGES.find(p => p.id === selectedPkg);

        //  calculate full range open/close times ────────────────────
        const startSlotIndex = fetchedSlots.findIndex(s => s.openTime === selectedSlot);
        const startSlot = fetchedSlots[startSlotIndex];
        const endSlot = fetchedSlots[startSlotIndex + pkgHours - 1];

        const fullSlotLabel = startSlot && endSlot
            ? `${startSlot.label?.split(" - ")[0] || startSlot.openTime} - ${endSlot.label?.split(" - ")[1] || endSlot.closeTime}`
            : (startSlot?.label || "");

        const reservationOrderData = {
            accountForm: "completed",
            pageStep: 4,

            userDetails: {
                first_name: form.firstName,
                last_name: form.lastName,
                mobile_no: form.phone,
                email: "",
            },
            reservationUserDetails: {
                first_name: form.firstName,
                last_name: form.lastName,
                mobile_no: form.phone,
                guests: form.guests,
            },

            delivery_mode: "pickup_point",
            delivery_type: "schedule",
            delivery_date: selectedDate ? selectedDate.toISOString() : "",

            timeSloat: {
                id: selectedSlot,
                label: fullSlotLabel,
                branchId: 0,
            },

            home_office: {
                id: 1,
                latitude: 24.7136,
                longitude: 46.6753,
                name: "Rabbithole Cafe",
                itemDetail: {
                    id: 1,
                    lattitude: 24.7136,
                    longitude: 46.6753,
                },
            },

            DeliveryModeActiveTab: 2,
            deliveryDateTimeActiveTab: 2,

            notes: form.special || "",

            isReservationFlow: true,

            reservationData: {
                packageId: selectedPkg,
                packageName: t(pkgData?.nameKey) || "",
                price: pkgData?.price || 0,
                hours: pkgData?.hours,
                people: pkgData?.people,
                chairs: pkgData?.chairs,
                tables: pkgData?.tables,
                cakes: pkgData?.cakes,
                date: selectedDate ? selectedDate.toISOString() : "",
                slotId: 0,
                // ── CHANGED: openTime is start of range, closeTime is end of range ──
                slotOpenTime: startSlot?.openTime || "",
                slotCloseTime: endSlot?.closeTime || "",
                slotLabel: fullSlotLabel,
                guests: form.guests,
                special: form.special,
                slot_open_time: startSlot?.openTime || "",
                slot_close_time: endSlot?.closeTime || "",
            },
        };

        if (!auth?.id) {
            const pendingData = {
                selectedPkg,
                selectedDate: selectedDate ? selectedDate.toISOString() : null,
                selectedSlot,
                form,
            };
            localStorage.setItem(PENDING_RESERVATION_KEY, JSON.stringify(pendingData));

            setLoginMsg(true);
            setTimeout(() => {
                setLoginMsg(false);
                setPendingLoginRedirect(true);
                navigate(`/login?redirect=${encodeURIComponent(location.pathname)}`);
            }, 1500);
            return;
        }

        localStorage.removeItem(PENDING_RESERVATION_KEY);
        dispatch(updateOrderData(reservationOrderData));

        setCompleted(p => new Set([...p, 3]));
        setOpenStep(null);
        setConfirmed(true);

        setTimeout(() => {
            // navigate("/cart");
            navigate(`/custom-cake-order/${CUSTOM.base64Encode(updateOrderData?.id)}`);
        }, 600);
    };

    useEffect(() => {
        if (!auth?.id) {
            const pendingData = {
                selectedPkg,
                selectedDate: selectedDate ? selectedDate.toISOString() : null,
                selectedSlot,
                form,
            };
            localStorage.setItem(PENDING_RESERVATION_KEY, JSON.stringify(pendingData));
        }
    }, [selectedPkg, selectedDate, selectedSlot, form, auth?.id]);

    const labelStyle = {
        color: "var(--Blacks-300, #6D737E)",
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "16px",
        display: "block",
        marginBottom: 6
    };

    const imageSlider = (
        <div
            style={{
                width: isMobile ? "100%" : 408,
                height: isMobile ? 358 : 436,
                borderRadius: 20,
                overflow: "hidden",
                position: "relative",
                flexShrink: 0,
                boxShadow: "0 10px 36px rgba(124,29,70,.18)",
                marginTop: isMobile ? 24 : 0,
                marginBottom: isMobile ? 12 : 0,
            }}
        >
            {images.map((src, i) => (
                <img key={src} src={src} alt="cafe"
                    style={{
                        position: "absolute", inset: 0, width: "100%", height: "100%",
                        objectFit: "cover", opacity: i === imgIdx ? 1 : 0,
                        transition: "opacity .7s ease",
                    }}
                />
            ))}
            <div style={{
                position: "absolute", bottom: 46, left: "50%",
                transform: "translateX(-50%)", display: "flex", gap: 6,
            }}>
                {images.map((_, i) => (
                    <div key={i} onClick={() => setImgIdx(i)} style={{
                        width: i === imgIdx ? 22 : 7, height: 7, borderRadius: 4,
                        background: i === imgIdx ? "white" : "rgba(255,255,255,.5)",
                        cursor: "pointer", transition: "all .3s",
                    }} />
                ))}
            </div>
            {[{ dir: -1, right: 44 }, { dir: 1, right: 10 }].map(({ dir, right }) => (
                <button key={right}
                    onClick={() => setImgIdx(i => (i + dir + images.length) % images.length)}
                    style={{
                        position: "absolute", bottom: 12, right,
                        background: "white", border: "none", borderRadius: "50%",
                        width: 30, height: 30, cursor: "pointer",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        boxShadow: "0 2px 8px rgba(0,0,0,.14)",
                    }}>
                    {dir === -1
                        ? <ChevronLeftIcon sx={{ fontSize: 18 }} />
                        : <ChevronRightIcon sx={{ fontSize: 18 }} />}
                </button>
            ))}
        </div>
    );

    return (
        <>
            <style>
                {`
               .hide-scrollbar::-webkit-scrollbar {
                   display: none;
               }
               .hide-scrollbar {
                   -ms-overflow-style: none;
                   scrollbar-width: none;
               }
            `}
            </style>
            <div style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif", background: "#F9F6F8", minHeight: "100vh" }}>

                <ConflictToast message={slotConflictMsg} visible={toastVisible} />

                {/* Breadcrumb */}
                <div style={{ padding: isMobile ? "16px 16px" : "16px 88px", fontSize: 14, color: "#aaa" }}>
                    {t("home")} &nbsp;&rsaquo;&nbsp;
                    <span style={{ color: PRIMARY, fontWeight: 700 }}>{t("Reservations")}</span>
                </div>

                <div style={{ width: "100%", maxWidth: 1280, margin: "0 auto", padding: isMobile ? "0 16px 100px" : "0 48px 100px", boxSizing: "border-box" }}>

                    <div style={{ display: "flex", gap: 40, alignItems: "flex-start", marginBottom: 40, flexWrap: "wrap" }}>

                        <div style={{ flex: 1, minWidth: 300 }}>
                            <h1 className="font-[Unbounded] text-[44px] text-[#771237] font-semibold" >
                                {t("reserveYour")}<br />{t("celebrationSpace")}
                            </h1>
                            <p className="text-[20px] font-[Inter] font-normal text-[#8D4660] leading-[28px]" style={{ maxWidth: 480 }}>
                                {t("hostYourCelebration")}
                            </p>

                            {isMobile && imageSlider}

                            <div className={isMobile ? "mt-[5%]" : "mt-[10%]"} style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                                <div
                                    style={{
                                        borderRadius: 16,
                                        background: `
                            linear-gradient(to bottom right, #E4F6F4 0%, #D4E9F2 25%, #CBEEF6 50%) bottom right / 50% 50% no-repeat,
                            linear-gradient(to bottom left, #E4F6F4 0%, #D4E9F2 25%, #CBEEF6 50%) bottom left / 50% 50% no-repeat,
                            linear-gradient(to top left, #E4F6F4 0%, #D4E9F2 25%, #CBEEF6 50%) top left / 50% 50% no-repeat,
                            linear-gradient(to top right, #E4F6F4 0%, #D4E9F2 25%, #CBEEF6 50%) top right / 50% 50% no-repeat,
                            linear-gradient(to bottom right, #FDF2F6 0%, #F2D9EF 50%) bottom right / 50% 50% no-repeat,
                            linear-gradient(to bottom left, #FDF2F6 0%, #F2D9EF 50%) bottom left / 50% 50% no-repeat,
                            linear-gradient(to top left, #FDF2F6 0%, #F2D9EF 50%) top left / 50% 50% no-repeat,
                            linear-gradient(to top right, #FDF2F6 0%, #F2D9EF 50%) top right / 50% 50% no-repeat
                            `,
                                        display: "flex",
                                        padding: 24,
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: 40,
                                        flex: "1 0 0"
                                    }}
                                >
                                    <div className="flex flex-row justify-between">
                                        <div
                                            style={{
                                                color: "#3E4147",
                                                fontFamily: "Inter",
                                                fontSize: 14,
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "20px",
                                                marginBottom: 4,
                                                minWidth: "220px"
                                            }}
                                        >
                                            {t("happyCelebrations")}
                                            <p
                                                style={{
                                                    fontSize: 24,
                                                    fontWeight: 900,
                                                    color: "#1a1a2e",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontFamily: "Unbounded",
                                                    gap: 8
                                                }}
                                            >
                                                500+
                                            </p>
                                        </div>
                                        <div className="bg-[white] ml-10 h-[40px] border rounded-full">
                                            <Img src="images/celebrate1.png" alt="celebration" className="w-10 h-10 object-fit" />
                                        </div>
                                    </div>

                                    <div style={{
                                        color: "#3E4147",
                                        fontFamily: "Inter",
                                        fontSize: 14,
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "20px",
                                        marginBottom: 4
                                    }}>
                                        {t("exclusiveCafeEventsWithPremiumService")}
                                    </div>
                                </div>
                                <div
                                    style={{
                                        borderRadius: 16,
                                        background: `
                            linear-gradient(to bottom right, #FDF2F6 0%, #F2D9EF 50%) bottom right / 50% 50% no-repeat,
                            linear-gradient(to bottom left, #FDF2F6 0%, #F2D9EF 50%) bottom left / 50% 50% no-repeat,
                            linear-gradient(to top left, #FDF2F6 0%, #F2D9EF 50%) top left / 50% 50% no-repeat,
                            linear-gradient(to top right, #FDF2F6 0%, #F2D9EF 50%) top right / 50% 50% no-repeat
                            `,
                                        display: "flex",
                                        padding: 24,
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: 40,
                                        flex: "1 0 0"
                                    }}
                                >
                                    <div className="flex flex-row justify-between">
                                        <div style={{
                                            color: "#3E4147",
                                            fontFamily: "Inter",
                                            fontSize: 14,
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "20px",
                                            marginBottom: 4,
                                            minWidth: "220px"
                                        }}>
                                            {t("customerRating")}
                                            <p
                                                style={{
                                                    fontSize: 24,
                                                    fontWeight: 900,
                                                    color: "#1a1a2e",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontFamily: "Unbounded",
                                                    gap: 8
                                                }}
                                            >
                                                4.8
                                            </p>
                                        </div>
                                        <div className="bg-[white] ml-10 h-[40px] border rounded-full">
                                            <Img src="images/stare.png" alt="rating" className="w-10 h-10 object-fit" />
                                        </div>
                                    </div>

                                    <div style={{
                                        color: "#3E4147",
                                        fontFamily: "Inter",
                                        fontSize: 14,
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "20px",
                                        marginBottom: 4
                                    }}>
                                        {t("greatSetisfactionFromOurGuest")}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {!isMobile && imageSlider}
                    </div>

                    {/* Step 1 */}
                    <Accordion
                        number={1}
                        title={<span className="reserve-title">{t("reserveYourStage")}</span>}
                        isOpen={openStep === 1}
                        isCompleted={completed.has(1)}
                        onToggle={() => toggle(1)}
                    >
                        <div
                            ref={sliderRef}
                            onMouseDown={onMouseDown}
                            onMouseLeave={onMouseLeave}
                            onMouseUp={onMouseUp}
                            onMouseMove={onMouseMove}
                            style={{ display: "flex", overflowX: "auto", gap: 16, marginBottom: 4, paddingBottom: 16, flexWrap: "nowrap", cursor: "grab" }}
                            className="hide-scrollbar"
                        >
                            {PACKAGES.map(pkg => (
                                <div key={pkg.id} style={{ flex: isMobile ? "0 0 85%" : "0 0 calc(30% - 11px)", minWidth: 260 }}>
                                    <PackageCard
                                        pkg={pkg}
                                        selected={selectedPkg === pkg.id}
                                        onSelect={() => handleSelectPkg(pkg.id)}
                                    />
                                </div>
                            ))}
                        </div>

                        <ContinueBtn disabled={!selectedPkg} onClick={() => finishStep(1, 2)} />
                    </Accordion>

                    {/* Step 2 */}
                    <Accordion number={2} title={<span className="reserve-title">{t("dateAndTime")}</span>}
                        isOpen={openStep === 2} isCompleted={completed.has(2)}
                        onToggle={() => toggle(2)}>

                        <div style={{ marginBottom: 26 }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 20, marginBottom: 18 }}>
                                <ChevronLeftIcon sx={{ color: "#bbb", cursor: "pointer", fontSize: 26 }} />
                                <span
                                    style={{
                                        color: "var(--Blacks-900, #1A1A1A)",
                                        textAlign: "center",
                                        fontFamily: "Inter",
                                        fontSize: 24,
                                        fontStyle: "normal",
                                        fontWeight: 500,
                                        lineHeight: "32px"
                                    }}
                                >
                                    {monthLabel}
                                </span>
                                <ChevronRightIcon sx={{ color: "#bbb", cursor: "pointer", fontSize: 26 }} />
                            </div>
                            <div style={{ display: "grid", gridTemplateColumns: isMobile ? "repeat(3, 1fr)" : "repeat(7, 1fr)", gap: isMobile ? 8 : 10 }}>
                                {days.map((d, i) => {
                                    const sel = selectedDate && d.toDateString() === selectedDate.toDateString();
                                    return (
                                        <div
                                            key={i}
                                            onClick={() => setSelectedDate(d)}
                                            style={{
                                                textAlign: "center",
                                                padding: isMobile ? "10px 4px" : "14px 6px",
                                                borderRadius: 14,
                                                cursor: "pointer",
                                                background: sel ? PRIMARY : "white",
                                                color: sel ? "white" : "var(--Blacks-400, #727783)",
                                                border: "1.5px solid " + (sel ? PRIMARY : "#E5E7EB"),
                                                transition: "all .2s",

                                                fontFamily: "Inter",
                                                fontSize: isMobile ? 13 : 18,
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: isMobile ? "18px" : "24px"
                                            }}
                                        >
                                            <div style={{ wordBreak: "break-word" }}>
                                                {t(DAY_NAMES[d.getDay()].toLowerCase())}
                                            </div>

                                            <div className={isMobile ? "pt-1.5 font-semibold text-lg" : "pt-3"}>
                                                {d.getDate()}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        <div>
                            <div
                                style={{
                                    color: "var(--Blacks-900, #1A1A1A)",
                                    fontFamily: "Inter",
                                    fontSize: 24,
                                    fontStyle: "normal",
                                    fontWeight: 500,
                                    lineHeight: "32px",
                                    marginBottom: 12
                                }}
                            >
                                {t("selectTimeSlot")}
                            </div>

                            {/* ── NEW: hint text showing how many consecutive slots will be selected ── */}
                            {/* {selectedPkg && pkgHours > 1 && (
                                <p style={{ color: "#6B7280", fontSize: 13, fontFamily: "Inter", marginBottom: 10 }}>
                                    {t("consecutiveSlotsHint") ||
                                        `Selecting a slot will automatically reserve ${pkgHours} consecutive hours for your package.`}
                                </p>
                            )} */}

                            {!selectedPkg && (
                                <p style={{ color: "#B45309", fontSize: 14, fontFamily: "Inter" }}>
                                    {t("pleaseSelectPackageFirst") || "Please select a package first to see available time slots."}
                                </p>
                            )}

                            {selectedPkg && !selectedDate && (
                                <p style={{ color: "#6B7280", fontSize: 14, fontFamily: "Inter" }}>
                                    {t("pleaseSelectDate")}
                                </p>
                            )}

                            {slotsLoading && (
                                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                                    {[1, 2, 3].map(n => (
                                        <div key={n} style={{
                                            padding: "11px 80px", borderRadius: 10, height: 50,
                                            background: "#F3F4F6", animation: "pulse 1.5s infinite",
                                        }} />
                                    ))}
                                </div>
                            )}

                            {!slotsLoading && slotsError && (
                                <p style={{ color: "#DC2626", fontSize: 14, fontFamily: "Inter" }}>{slotsError}</p>
                            )}

                            {!slotsLoading && !slotsError && fetchedSlots.length > 0 && (
                                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                                    {fetchedSlots.map((slot) => {
                                        const inRange = isSlotInRange(slot);
                                        const isStart = isSlotRangeStart(slot);
                                        const isEnd = isSlotRangeEnd(slot);

                                        let bgColor = "white";
                                        let borderColor = "#E5E7EB";
                                        let textColor = "var(--Blacks-400, #727783)";

                                        if (slot.reserved) {
                                            bgColor = "#F3F4F6";
                                            textColor = "#C4C4C4";
                                        } else if (inRange) {
                                            bgColor = PRIMARY;
                                            borderColor = PRIMARY;
                                            textColor = "white";
                                        }

                                        return (
                                            <button
                                                key={slot.openTime}
                                                onClick={() => handleSlotClick(slot)}
                                                style={{
                                                    padding: "11px 20px",
                                                    borderRadius: 10,
                                                    border: "1.5px solid " + borderColor,
                                                    background: bgColor,
                                                    color: textColor,
                                                    cursor: slot.reserved ? "not-allowed" : "pointer",
                                                    fontFamily: "Inter",
                                                    fontSize: 18,
                                                    fontStyle: "normal",
                                                    fontWeight: inRange ? 600 : 400,
                                                    lineHeight: "28px",
                                                    textAlign: "center",
                                                    opacity: slot.reserved ? 0.6 : 1,
                                                    pointerEvents: slot.reserved ? "none" : "auto",
                                                    textDecoration: slot.reserved ? "line-through" : "none",
                                                    // borderRadius: inRange
                                                    //     ? isStart ? "10px 0 0 10px" : isEnd ? "0 10px 10px 0" : "0"
                                                    //     : 10,
                                                    transition: "all .2s",
                                                }}
                                            >
                                                {slot.label}
                                                {slot.reserved ? " " + t("reservedTag") : ""}
                                            </button>
                                        );
                                    })}
                                </div>
                            )}

                        </div>

                        <ContinueBtn disabled={!selectedDate || !selectedSlot} onClick={() => finishStep(2, 3)} />
                    </Accordion>

                    {/* Step 3 */}
                    <Accordion number={3} title={<span className="reserve-title">{t("addYourInformation")}</span>}
                        isOpen={openStep === 3} isCompleted={completed.has(3)}
                        onToggle={() => toggle(3)}>

                        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 18 }}>

                            <div>
                                <label style={labelStyle}>{t("firstName")} <span className="text-[red]">*</span></label>
                                <input
                                    placeholder={t("enterYourFirstName")}
                                    value={form.firstName}
                                    onChange={e => setForm(p => ({ ...p, firstName: e.target.value }))}
                                    style={{
                                        width: "100%",
                                        border: "1.5px solid #E5E7EB",
                                        borderRadius: 10,
                                        padding: "13px 16px",
                                        fontSize: 15,
                                        outline: "none",
                                        fontFamily: "inherit"
                                    }}
                                />
                            </div>

                            <div>
                                <label style={labelStyle}>{t("lastName")} <span className="text-[red]">*</span></label>
                                <input
                                    placeholder={t("enterYourLastName")}
                                    value={form.lastName}
                                    onChange={e => setForm(p => ({ ...p, lastName: e.target.value }))}
                                    style={{
                                        width: "100%",
                                        border: "1.5px solid #E5E7EB",
                                        borderRadius: 10,
                                        padding: "13px 16px",
                                        fontSize: 15,
                                        outline: "none",
                                        fontFamily: "inherit"
                                    }}
                                />
                            </div>

                            <div>
                                <label style={labelStyle}>{t("mobileNumber")} <span className="text-[red]">*</span></label>
                                <div style={{ display: "flex", border: "1.5px solid #E5E7EB", borderRadius: 10, overflow: "hidden" }}>
                                    <div style={{
                                        padding: "13px 16px", background: "#F9FAFB",
                                        borderRight: "1.5px solid #E5E7EB", fontSize: 15,
                                        color: "#555", fontWeight: 700, whiteSpace: "nowrap",
                                    }}>
                                        +966
                                    </div>
                                    <input placeholder="XXX XXX XXX" value={form.phone}
                                        maxLength={9}
                                        onChange={e => setForm(p => ({ ...p, phone: e.target.value }))}
                                        style={{ flex: 1, border: "none", outline: "none", padding: "13px 16px", fontSize: 15, fontFamily: "inherit" }} />
                                </div>
                            </div>

                            <div>
                                <label style={labelStyle}>{t("numberOfGuests")} <span className="text-[red]">*</span></label>

                                <input
                                    placeholder="e.g. 10"
                                    value={form.guests}
                                    onChange={e => setForm(p => ({ ...p, guests: e.target.value }))}
                                    style={{
                                        width: "100%",
                                        border: "1.5px solid #E5E7EB",
                                        borderRadius: 10,
                                        padding: "13px 16px",
                                        fontSize: 15,
                                        outline: "none",
                                        fontFamily: "inherit"
                                    }}
                                />
                            </div>

                            <div style={{ gridColumn: "1 / -1" }}>
                                <label style={labelStyle}>{t("specialRequests")} <span className="text-[red]">*</span></label>
                                <textarea
                                    placeholder={t("doYouHaveAnyNote")}
                                    value={form.special}
                                    onChange={e => setForm(p => ({ ...p, special: e.target.value }))}
                                    style={{
                                        width: "100%", border: "1.5px solid #E5E7EB", borderRadius: 10,
                                        padding: "13px 16px", fontSize: 15, minHeight: 100,
                                        resize: "vertical", outline: "none", boxSizing: "border-box", fontFamily: "inherit",
                                    }}
                                    onFocus={e => (e.target.style.borderColor = PRIMARY)}
                                    onBlur={e => (e.target.style.borderColor = "#E5E7EB")}
                                />
                            </div>
                        </div>
                    </Accordion>

                    {pendingLoginRedirect && (
                        <div style={{
                            background: "#FFF7ED",
                            border: "1.5px solid #FDBA74",
                            borderRadius: 14,
                            padding: "18px 24px",
                            marginBottom: 16,
                            display: "flex",
                            alignItems: "center",
                            gap: 14,
                        }}>
                            <div>
                                <div style={{ fontWeight: 700, fontSize: 15, color: "#92400E", fontFamily: "Unbounded" }}>
                                    {t("loginRequired")}
                                </div>
                                <div style={{ fontSize: 14, color: "#B45309", marginTop: 4, fontFamily: "Inter" }}>
                                    {t("pleaseLoginToContinueReservation")}
                                </div>
                            </div>
                        </div>
                    )}

                    {loginMsg && (
                        <div style={{
                            background: "#FEF2F2",
                            border: "1.5px solid #FECACA",
                            borderRadius: 14,
                            padding: "14px 20px",
                            marginBottom: 12,
                            display: "flex",
                            alignItems: "center",
                            gap: 12,
                        }}>
                            <span style={{ fontSize: 14, color: "#B91C1C", fontFamily: "Inter", fontWeight: 500 }}>
                                {t("pleaseLoginForReservation")}
                            </span>
                        </div>
                    )}

                    {/* ── Confirm Reservation Button / Confirmed State ───────────────────── */}
                    {confirmed ? (
                        <div style={{
                            textAlign: "center", background: "white", borderRadius: 16,
                            padding: "40px 24px", boxShadow: "0 2px 16px rgba(0,0,0,.08)",
                        }}>
                            {/* Confirmed state UI placeholder */}
                        </div>
                    ) : (
                        <button
                            onClick={handleConfirmReservation}
                            style={{
                                width: "100%",
                                background: allReady ? PRIMARY : "#D1D5DB",
                                color: "white", border: "none", borderRadius: 30,
                                padding: "20px", fontWeight: 500, fontSize: 16,
                                cursor: allReady ? "pointer" : "not-allowed",
                                marginTop: 10, fontFamily: "Unbounded", letterSpacing: ".3px",
                                transition: "background .2s",
                            }}>
                            {t("confirmReservation")}
                        </button>
                    )}
                </div>
            </div>
            <div>
                <Footer />
            </div>
        </>
    );
}